(function ($) {
  $(function () {
    var $siteHeader = $('.site-header.is-sticky');

    if ($siteHeader.length) {
      $(window).on('scroll', function () {
        $siteHeader.toggleClass('navbar-fixed-top', $(this).scrollTop() > 1);
      });
    }

    $(window).on('scroll', function () {
      $('.scroll-to-top').toggleClass('show', $(this).scrollTop() > 150);
    });

    $('.scroll-to-top').on('click', function (event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: 0
      }, 700);
    });
  });
})(jQuery);
